import { useCallback, useEffect, useRef, useState } from "react";
export const useCounters = (time) => {
    const [count, setCount] = useState(time);
    const counterTimerRef = useRef();
    const getCurrentCount = (expireTime) => Math.ceil((expireTime - Date.now()) / 1000);
    const clearTimer = useCallback(() => {
        clearInterval(counterTimerRef.current);
    }, []);
    useEffect(() => {
        return () => {
            clearTimer();
        };
    }, [clearTimer]);
    const tickTimer = useCallback((expireTime) => {
        const remainCount = getCurrentCount(expireTime);
        setCount(remainCount);
        if (remainCount === 0) {
            clearTimer();
        }
    }, [clearTimer]);
    const startCounter = useCallback(() => {
        const expireTime = Date.now() + time * 1000;
        setCount(getCurrentCount(expireTime));
        counterTimerRef.current = setInterval(() => tickTimer(expireTime), 1000);
    }, [tickTimer, time]);
    const resetTimer = useCallback(() => {
        clearTimer();
        startCounter();
    }, [clearTimer, startCounter]);
    return {
        resetTimer,
        clearTimer,
        startCounter,
        remainingTime: Math.max(count, 0),
    };
};
//# sourceMappingURL=useCounters.js.map